import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

export const useCurrentImageLibrary = () => {
  const workspace = useCurrentWorkspace()
  return workspace?.image_library_project
}
